import { CustomReportRequest, zSchema } from "@zeal/common";

export const customReportTemplates = {
  worker_summary: "worker_summary",
  contractor_summary: "contractor_summary",
} as const;

export type TCustomReportTemplate =
  (typeof customReportTemplates)[keyof typeof customReportTemplates];

export const getCustomReportConfigsRequestSchema = zSchema.object({
  template: zSchema.nativeEnum(customReportTemplates),
});

export type TGetCustomReportConfigsRequestSchema = zSchema.infer<
  typeof getCustomReportConfigsRequestSchema
>;

export type TGetCustomReportConfigsResponseSchema = {
  template: CustomReportRequest;
};
